/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Template/view.blocks to change it.
import React from 'react'
import Type from './Type/index'
import Value from './Value/index'



/** @type {import('Simple/types.js').View} */
export default function Template({
  children,
  viewPath = "/App/Account/NewPatient/Content/Form/ReferralsSection/Referrals/Referral/Kind/Template"
  
}) {
  return (<React.Fragment
>
<Type
  viewPath={`${viewPath}/Type`}
/>
<Value
  viewPath={`${viewPath}/Value`}
/>
{children}
</React.Fragment>)
}